import { resetChromeRecommendationToast } from "./browserSupport";

export type AuthSessionExpiryReason = "inactive" | "absolute";

const STARTED_AT_KEY = "viewrAuthSessionStartedAt";
const LAST_ACTIVE_AT_KEY = "viewrAuthSessionLastActiveAt";
const INACTIVE_MS = 14 * 24 * 60 * 60 * 1000;
const ABSOLUTE_MS = 30 * 24 * 60 * 60 * 1000;

const readTime = (key: string): number | null => {
  const value = Number(localStorage.getItem(key));
  return Number.isFinite(value) && value > 0 ? value : null;
};

export const beginAuthSession = (
  startedAtMs: number,
  nowMs: number = Date.now(),
): void => {
  localStorage.setItem(STARTED_AT_KEY, String(startedAtMs));
  localStorage.setItem(LAST_ACTIVE_AT_KEY, String(nowMs));
};

export const ensureAuthSession = (
  startedAtMs: number,
  nowMs: number = Date.now(),
): void => {
  if (readTime(STARTED_AT_KEY) !== startedAtMs) {
    beginAuthSession(startedAtMs, nowMs);
  } else if (readTime(LAST_ACTIVE_AT_KEY) === null) {
    localStorage.setItem(LAST_ACTIVE_AT_KEY, String(nowMs));
  }
};

export const ensureStoredAuthSession = (nowMs: number = Date.now()): void => {
  const startedAtMs = readTime(STARTED_AT_KEY);
  if (startedAtMs === null) {
    beginAuthSession(nowMs, nowMs);
  } else if (readTime(LAST_ACTIVE_AT_KEY) === null) {
    localStorage.setItem(LAST_ACTIVE_AT_KEY, String(nowMs));
  }
};

export const getAuthSessionExpiry = (
  nowMs: number = Date.now(),
): AuthSessionExpiryReason | null => {
  const startedAtMs = readTime(STARTED_AT_KEY);
  const lastActiveAtMs = readTime(LAST_ACTIVE_AT_KEY);
  if (startedAtMs === null || lastActiveAtMs === null) return null;
  if (nowMs - startedAtMs >= ABSOLUTE_MS) return "absolute";
  if (nowMs - lastActiveAtMs >= INACTIVE_MS) return "inactive";
  return null;
};

export const recordAuthSessionActivity = (nowMs: number = Date.now()): void => {
  if (readTime(STARTED_AT_KEY) !== null) {
    localStorage.setItem(LAST_ACTIVE_AT_KEY, String(nowMs));
  }
};

export const clearAuthSession = (): void => {
  if (readTime(STARTED_AT_KEY) !== null) resetChromeRecommendationToast();
  localStorage.removeItem(STARTED_AT_KEY);
  localStorage.removeItem(LAST_ACTIVE_AT_KEY);
};
